// extracted by mini-css-extract-plugin
export var orderSummary = "_qp-0";
export var showMoreLessButton = "_qp-1";